import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";
import FileUpload from "./FileUpload";
import axios from "axios";
import TableComponent from "./TableComponent";
import Productb from "./Productb";
import EditPage from "./EditPage";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Searches from "./Searches";
import "./App.css";
import Details from "./Details";
import DocumentCheckList from "./DocumentCheckList";
import FinancialAnalysis from "./FinancialAnalysis";
import CompanyScore from "./CompanyScore";
import DashboardDemo from "./DashBoardDemo";
import CompanyInformation from "./CompanyInformation";
import TransactionFiles from "./TransactionFiles";
import TransactionLog from "./TransactionLog";
import TransactionList from "./TransactionList";
import ViewTransactionList from "./ViewTransactionList";
import ApplicationChecklist from "./ApplicationChecklist";
import ScoringCriteria from "./ScoringCriteria";
import ScoringCriteriaTF from "./ScoringCriteriaTf";
import SavedCriteriaList from "./SavedCriteriaList";
import AddCompany from "./AddCompany";
import ScoreCard from "./ScoreCard";
import TransactionSummary from "./TransactionSummary";
import TermSheet from "./TermSheet";
import Payments from "./Payments";
import RepaymentAndInterest from "./RepaymentAndInterest";
import ScoringGuide from "./ScoringGuide";
import InterestCalculations from "./InterestCalculations";

function App() {
  const [items, setItems] = useState("");

  const API_URL = "http://localhost:5001/api";

  const handleDelete = async (index) => {
    try {
      const response = await axios.delete(`${API_URL}/delete/${index}`);
      console.log("Item deleted successfully:", response.data);
    } catch (error) {
      console.error(
        "Error deleting item:",
        error.response?.data || error.message
      );
      alert("Failed to delete item.");
    }
  };

  const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
      const isAuthenticated = localStorage.getItem("isAuthenticated");
      if (isAuthenticated !== "true") {
        navigate("/"); // Redirect to login if not authenticated
      }
    }, [navigate]);

    return children;
  };

  // useEffect(() => {
  //   const fetchSitesB = async () => {
  //     try {
  //       const response = await fetch(`${API_URL}/sitesb`);
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       const data = await response.json();

  //       console.log("Fetched product B Data:", data?.isheet?.data?.item);
  //       setItemsB(data?.isheet?.data?.item);
  //       console.log("itemsB:", itemsB);
  //     } catch (error) {
  //       setError(error.message);
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchSitesB();
  // }, []);

  const handleEdit = (updatedItem) => {
    setItems(
      items.map((item) =>
        item.itemid === updatedItem.itemid ? updatedItem : item
      )
    );
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard items={items} />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Login />} />
        <Route
          path="/producta"
          element={<TableComponent handleDelete={handleDelete} />}
        />
        <Route path="/productb" element={<Productb />} />
        <Route path="/details/:id" element={<Details />} />
        <Route path="/documentCheckList/:id" element={<DocumentCheckList />} />
        <Route path="/searches/:id" element={<Searches />} />
        <Route path="/financialAnalysis/:id" element={<FinancialAnalysis />} />
        <Route path="/companyScore/:id" element={<CompanyScore />} />
        <Route path="/DashboardDemo" element={<DashboardDemo />} />
        <Route path="/TransactionFiles" element={<TransactionFiles />} />
        <Route
          path="/CompanyInformation/:id"
          element={<CompanyInformation />}
        />
        <Route
          path="/ViewTransactionList/:id"
          element={<ViewTransactionList />}
        />
        <Route path="/TransactionList/:id" element={<TransactionList />} />
        <Route path="/AddCompany" element={<AddCompany />} />
        <Route path="/TransactionLog/:id" element={<TransactionLog />} />
        <Route
          path="/ApplicationChecklist/:id"
          element={<ApplicationChecklist />}
        />
        <Route path="/ScoreCard/:id" element={<ScoreCard />} />
        <Route
          path="/TransactionSummary/:id"
          element={<TransactionSummary />}
        />
        <Route path="/ScoringCriteria/:id" element={<ScoringCriteria />} />
        <Route path="/ScoringCriteriaTF/:id" element={<ScoringCriteriaTF />} />
        <Route
          path="/InterestCalculations/:id"
          element={<InterestCalculations />}
        />
        <Route path="/ScoringGuide/:id" element={<ScoringGuide />} />
        <Route path="/TermSheet/:id" element={<TermSheet />} />
        <Route path="/Payments/:id" element={<Payments />} />
        <Route
          path="/RepaymentAndInterest/:id"
          element={<RepaymentAndInterest />}
        />
        <Route path="/SavedCriteriaList" element={<SavedCriteriaList />} />
        <Route
          path="/edit/:id"
          element={<EditPage items={items} handleEdit={handleEdit} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
